import React from 'react';
import "../scss/Button.scss"

const Button = ({ children, className = "", onClick = undefined, load = false, disable = false }) => {
  return (
    <button onClick={(!disable && !load) ? onClick : undefined} disabled={disable} className={`btn ${className} ${disable ? "disable" : ""} ${load ? "loading" : ""}`}>
      {load ? (
        <svg width="25" height="24" className='loader' viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className='path-btn' fill-rule="evenodd" clip-rule="evenodd" d="M10.4428 3.17887C10.6269 3.69958 10.354 4.27091 9.83325 4.45495C6.72472 5.55366 4.5 8.51831 4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 8.51831 18.2753 5.55366 15.1668 4.45495C14.646 4.27091 14.3731 3.69958 14.5572 3.17887C14.7412 2.65815 15.3125 2.38523 15.8332 2.56927C19.7159 3.94158 22.5 7.64437 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 7.64437 5.28413 3.94158 9.16675 2.56927C9.68747 2.38523 10.2588 2.65815 10.4428 3.17887Z" fill="#17171A"/>
        </svg>
      ) : (
        children
      )}
    </button>
  )
}

export default Button;
